import { Component, OnInit, Inject } from '@angular/core';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { UserService } from '../../../services/user.service';
import { PartnersAccountModalComponent } from 'src/app/contexts/partners/pages/detail/modals/partners-account-modal.component';
import { MatDialog } from '@angular/material/dialog';
@Component({
    selector: 'app-custom-dropdown-bottom.component',
    templateUrl: './custom-dropdown-bottom.component.html',
    styleUrls: ['./custom-dropdown-bottom.component.scss']
})
export class CustomDropdownBottomComponent implements OnInit {

    model: any = {};

    constructor(
        private bottomSheetRef: MatBottomSheetRef<CustomDropdownBottomComponent>,
        @Inject(MAT_BOTTOM_SHEET_DATA) public data,
        private userService: UserService,
        private dialog: MatDialog
    ) { }


    async ngOnInit() {

        this.model.items = this.data.items;
        this.model.display = this.data.display;
        this.model.selectedItem = this.data.selectedItem;
        this.model.partner = this.data.partner;
        this.model.account = this.data.account;

        this.model.user = this.userService.user;
    }

    changeItem(item: any, redirectTo: string) {
        this.bottomSheetRef.dismiss({ item, redirectTo });
    }

    addAccount() {
        this.dialog.open(PartnersAccountModalComponent, {
            width: '700px',
            data: {
                partner: this.model.partner,
                account: this.model.account,
                partner_obj: { key: this.model.partner, user: { username: this.userService.user.email } }
            },
            autoFocus: false
        }).afterClosed().subscribe(result => {
            if (result) {
                this.model.items.push({ key: result.accounts[0].account_key, name: result.accounts[0].account_name });
            }
        });
    }
}
